import React, { useState, useEffect, Fragment } from "react";
import { Card, Modal } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import Select from "react-select";
import { stufeetypecreate, stufeetypedelete, stufeetypedetail, stufeetypelist, stufeetypeupdate, stufeetypevalidate, vehroutelist } from "../../../services/master";
import { academylist } from "../../../services/admin";

export const FeeTypeMaster = () => {
  const [filterProduct, setFilterProduct] = useState([]);
  const [Catid, setID] = useState(0);
  const [name, setName] = useState("");
  const [ftype, setFType] = useState("1");
  const [vroute, setVroute] = useState("");
  const [vrlist, setVrlist] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");
  useEffect(() => {
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });

    funlist();
  }, []);

  function funlist() {
    setFilterProduct([]);
    const temp = new FormData();
    stufeetypelist(temp).then((res) => {
      if (res.status === true) {
        // setFilterProduct(res.data);
        const sdata = res.data.map((item) => ({
            ...item,
            feestype: item.feestype == 1 ? "Common" : item.feestype == 2 ? "Hostel" : item.feestype == 3 ? "Bus" : "",
        }))
        setFilterProduct(sdata);
      }
    });

  }
  const columnDefs = [
    {
      headerName: "Fee Type",
      field: "fee_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Type",
      field: "feestype",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Route",
      field: "vehroute_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    // {
    //   headerName: "Status",
    //   width: 150,
    //   field: "active",
    //   sortable: true,
    //   resizable: true,
    //   filter: true,
    //   floatingFilter: true,
    //   cellRenderer: function (params) {
    //     return (
    //       <div className="text-center">
    //         <label className="custom-switch mb-0">
    //           <input
    //             type="checkbox"
    //             name="custom-switch-checkbox"
    //             className="custom-switch-input"
    //             checked={params.value === 1 ? true : false}
    //             onChange={() => handleSwitch(params)}
    //           />

    //           <span className="custom-switch-indicator"></span>
    //         </label>
    //       </div>
    //     );
    //   },
    // },

    {
      headerName: "Actions",
      field: "id",
      resizable: true,
      filter: false,
      // headerClass: "ag-center-aligned-header",
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => viewshow(params.value)}
              className="btn-sm btn-info"
            >
              <i className="fa fa-edit"></i>
            </a>
          </div>
        );
      },
    },
  ];

  function handleSwitch(list) {
    if (list.value === 1) {
      Swal.fire({
        text: "Are you sure want to Inactive?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ac0404",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Inactive",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const temp = new FormData();
          temp.append("id", list.data.id);
          temp.append("status", 0);

          stufeetypedelete(temp).then((response) => {
            if (response.status === true) {
              funlist();
            }
          });
        }
      });
    } else {
      Swal.fire({
        text: "Are you sure want to Active?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#008000",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Active",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const temp = new FormData();
          temp.append("id", list.data.id);
          temp.append("status", 1);

          stufeetypedelete(temp).then((response) => {
            if (response.status === true) {
              funlist();
            }
          });
        }
      });
    }
  }

  const [show, setShow] = useState(false);
  function handleshow() {
    setID(0);
    setName("");
    setVroute("");
    setFType(1);
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listall(arr[0]);
              }
            }

          }
        }
      });
    }
    setErrorMessage("");
    setShow(true);
  }

  function handleclose() {
    setID(0);
    setVroute("");
    setFType(1);
    setAcaID("");
    setErrorMessage("");
    setShow(false);
  }

  function viewshow(vid) {
    setID(vid);
    setName("");
    setShow(true);

    setErrorMessage("");
    stufeetypedetail(vid).then((response) => {
      if (response.status === true) {
        setName(response.data.fee_type);
        if (response.data.feestype) {
          setFType(String(response.data.feestype));
        }
        if (response.data.fee_route !== null) {
          setVroute(response.data.fee_route);
        }
        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].id === response.data.academy_id) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].name + " - " + res.data.details[i].code,
                  });
                }
              }
              setAcaID(arr[0]);
              listall(arr[0]);
            }
          }
        });
      }
    });
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e);
    } else {
      setAcaID("");
      listall("");
    }
  }
  function listall(aid) {
    setVrlist([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    vehroutelist(temp).then((res) => {
      if (res.status === true) {
        setVrlist(res.data);
        
      }
    });

  }
  function Submitage() {
    setErrorMessage("");
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        setErrorMessage("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }
    if (valid === "") {
      if (name !== "") {

        const temp = new FormData();
        temp.append("name", name);
        temp.append("id", Catid);
        if (localStorage.getItem("Role") === "1" && acaid !== "") {
          temp.append("academy_id", acaid.value);
        }
        stufeetypevalidate(temp).then((response) => {
          if (response.status === false) {

            setErrorMessage(response.message);
          } else {
            console.log(vroute);
            const tempData = new FormData();
            tempData.append("name", name);
            tempData.append("route", vroute !== "" ? vroute : 0);
            tempData.append("type", ftype);
            tempData.append("user_id", localStorage.getItem("UID"));
            if (localStorage.getItem("Role") === "1" && acaid !== "") {
              tempData.append("academy_id", acaid.value);
            }
            if (Catid === 0) {
              stufeetypecreate(tempData).then((response) => {
                if (response.status === true) {
                  handleclose();
                  funlist();
                  toast.success(response.message);
                } else {
                  setErrorMessage(response.data.message);
                }
              });
            } else {
              tempData.append("id", Catid);
              stufeetypeupdate(tempData).then((response) => {
                if (response.status === true) {
                  handleclose();
                  funlist();
                  toast.success(response.message);
                } else {
                  setErrorMessage(response.data.message);
                }
              });
            }
          }
        });


      } else {
        setErrorMessage("Please Enter Fee Type");
      }
    }

  }

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Fee Type List</h2>
        </div>
      </div>
      <Row className="row-sm mx-0 mt-3">
        <Col xxl={12} lg={12} md={12}>
          <Card className="custom-card overflow-hidden">
            <Card.Body>
              <div className="responsive">
                <div className="res-right">
                  <a
                    onClick={handleshow}
                    variant="success"
                    type="button"
                    className="btn my-1 me-2 btn-success tx-teko"
                  >
                    {" "}
                    Add
                  </a>
                </div>
                <div className="ag-theme-alpine ag-style">
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                  />
                </div>
              </div>

              <Modal show={show}>
                <Modal.Header>
                  {Catid === 0 ? <h4>Add Fee Type</h4> : <h4>Fee Type Detail</h4>}
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                    {localStorage.getItem("Role") === "1" && (
                      <Col lg={12} md={12}>
                        <div className="form-label">
                          <label className="mb-2">
                            Select Academy
                            <span className="text-danger"> *</span>

                          </label>
                        </div>
                        <Select
                          className="default-select"
                          placeholder="Select Academy"
                          value={acaid}
                          options={alist}
                          onChange={handleAcademy}
                          isSearchable={true}
                          isClearable
                          hidden
                        />

                      </Col>
                    )}

                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="mb-2">
                          Type<span className="text-danger"> *</span>
                        </label>
                      </div>
                      <div className="form-group">
                        <select
                          className="default-select form-control wide"
                          value={ftype}
                          onChange={(e) => {
                            const t = e.target.value;
                            setFType(t);
                            // Bus fee names are derived from the route; clear so the
                            // user picks a route. Other types are entered manually.
                            setVroute("");
                            setName("");
                          }}
                        >
                          <option value="" disabled>
                            Select Type
                          </option>
                          <option value="1">Common</option>
                          <option value="2">Hostel</option>
                          <option value="3">Bus</option>
                        </select>
                      </div>
                    </Col>
                    {ftype == 3 &&
                      <Col lg={12} md={12}>
                        <div className="form-group">
                          <label className="mb-2">
                            Route<span className="text-danger"> *</span>
                          </label>
                        </div>
                        <div className="form-group">
                          <select
                            className="default-select form-control wide"
                            value={vroute}
                            onChange={(e) => {
                              const rid = e.target.value;
                              setVroute(rid);
                              // Auto-name the Bus fee type as "<route name> Bus".
                              const r = vrlist.find((item) => String(item.id) === String(rid));
                              setName(r ? `${r.vehroute_name} Bus Fee` : "");
                            }}
                          >
                            <option value="" disabled>
                              Select Route Name
                            </option>
                            {vrlist.map((item, index) => {
                              return (
                                <option key={index} value={item.id}>
                                  {item.vehroute_name}
                                </option>
                              );
                            })

                            }
                          </select>
                        </div>
                      </Col>
                    }
                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="mb-2">
                          Fee Type <span className="text-danger"> *</span>
                        </label>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder={ftype == 3 ? "Auto-filled from selected route" : "Enter Your Fee Type"}
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          readOnly={ftype == 3}
                        />
                      </div>
                    </Col>





                    {errorMessage !== "" && (
                      <span className="text-danger">{errorMessage}</span>
                    )}
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  {Catid === 0 ? (
                    <a
                      onClick={Submitage}
                      className="btn btn-next btn-success"
                      style={{ float: "right" }}
                    >
                      Submit
                    </a>
                  ) : (
                    <a
                      onClick={Submitage}
                      className="btn btn-next btn-success"
                      style={{ float: "right" }}
                    >
                      Update
                    </a>
                  )}
                  <a
                    className="btn btn-next btn-secondary"
                    style={{ float: "right" }}
                    onClick={handleclose}
                  >
                    Close
                  </a>
                </Modal.Footer>
              </Modal>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};
